import React from "react";
import { Card } from "../../ui";

const toneColor = {
  slate: "text-gray-600",
  red: "text-red-600",
  orange: "text-orange-600",
  yellow: "text-yellow-600",
  green: "text-green-600",
  blue: "text-blue-600",
  purple: "text-purple-600",
  cyan: "text-cyan-600",
};

const KpiCard = ({ label, value, icon: Icon, tone = "slate", sub }) => (
  <Card className="p-5" padded={false} hover={false}>
    <div className="flex justify-between items-center">
      <h3 className="text-gray-500 text-sm">{label}</h3>
      {Icon && <Icon className={`w-5 h-5 ${toneColor[tone] || toneColor.slate}`} />}
    </div>
    <p className="text-3xl font-bold mt-4 text-gray-900">{value}</p>
    {sub && <p className="text-xs text-gray-400 mt-1">{sub}</p>}
  </Card>
);

export default KpiCard;
